import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { IPayload } from 'Model/IPayload';
import { API_URL, apiMethod, apiType, getFileName } from 'utils';
import { GET_MAKE_LIST, GET_VEHICLE_SPEC_LIST, GET_VEHICLE_TYPE, GET_MANAGED_EQUIPEMENT_TYPES, GET_CATALOG_ITEMS, UPLOAD_BULK_ORDER_ATTACHMENTS, GET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN } from 'Store/Component/BulkOrder/BulkOrderType';
import AssetManagementApiService from 'Service/AssetManagement/AssetManagementApiService';
import { setVehicleType, setMakeList, setVehicleSpecList, setManagedEquipementTypes, setCatalogItems, setBulkOrderAttachments, setBulkOrderManagedEquipmentDropDown } from 'Store/Component/BulkOrder/BulkOrderAction';


function* getVehicleType(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/assetsubtypes/${req?.assetSubTypeId}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching Vehicle Types...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setVehicleType(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setVehicleType([]))
        yield put(globalLoaderText(""));
    }
}

function* getMakeList(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/make/${req?.orderRequestSubTypeId}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching Make List...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setMakeList({response, requestIndex: req?.requestIndex}))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setMakeList([]))
        yield put(globalLoaderText(""));
    }
}

function* getVehicleSpecList(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/catalogspecification/${req?.make}/${req?.orderRequestSubTypeId}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching Vehicle Specification List...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setVehicleSpecList({response, requestIndex: req?.requestIndex}))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setVehicleSpecList([]))
        yield put(globalLoaderText(""));
    }
}

function* getEquipmentDropdown(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.AssetManagement,
        endpoint: `assets/dropdown/assetsubtypes/${req?.assetSubTypeId}`,
        payload: null
    }
    try {
        yield put(globalLoaderText("Fetching Equipment Types...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        yield put(setManagedEquipementTypes(response))
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setManagedEquipementTypes([]))
        yield put(globalLoaderText(""));
    }
}

function* getCatalogItem(req: any): any {
    let payloadData: IPayload = {
        apiMethod: apiMethod.POST,
        apiType: apiType.AssetManagement,
        endpoint: `assets/managedequipment/catalogitems`,
        payload: req?.payload
    }
    try {
        yield put(globalLoaderText("Fetching CatalogItem...."));
        const response = yield call(
            AssetManagementApiService.post,
            API_URL.PostWebApp, payloadData
        );
        if(response){
            yield put(setCatalogItems({response, requestIndex: req?.requestIndex}))
        }else{
            yield put(setCatalogItems({response: [], requestIndex: req?.requestIndex}))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setCatalogItems({}))
        yield put(globalLoaderText(""));
    }
}

function* uploadBulkOrderAttachments(req: any): any {
    try {
        yield put(globalLoaderText("Uploading Attachments...."));
        let fileObjList = req.attachmentList.formData;
        const list = req.attachmentList.filteredList;
        const CurrentAttachmentlist = req.attachmentList.list;

        fileObjList.append("apiMethod", apiMethod.POST)
        fileObjList.append("apiType", apiType.AssetManagement)
        fileObjList.append("endpoint", `assets/upload/attachments`) 
        
        const response = yield call(AssetManagementApiService.post, `${API_URL.PostWebApp}/upload/attachments`, fileObjList);

        // Converting attachment URL to object
        const updatedResponse = response
            .map((x: string) => {
                const obj = list.find((y: any) => getFileName(x) === y.name);
                if (obj) {
                    return {
                        fileName: obj.name,
                        mimeType: obj.type,
                        attachmentUrl: x,
                        isFleet: true
                    };
                }

                return null;
            })
            .filter((x: any) => !!x);
        yield put(globalLoaderText(""));
        yield put(setBulkOrderAttachments([...CurrentAttachmentlist, ...updatedResponse], req?.requestIndex));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setBulkOrderAttachments([], req?.requestIndex));
    }
}

function* getBulkOrderManagedEquipmentDropDown(val: any): any {
    let payloadData : IPayload = {
        apiType : apiType.AssetManagement,
        endpoint : `assets/dropdown/${val.assetSubTypeId}`,
        apiMethod : apiMethod.GET,
        payload : null
    }
    try {
        yield put(globalLoaderText("Fetching Drop Down values...."));

        const response = yield call(
            AssetManagementApiService.post,API_URL.PostWebApp,payloadData
            
        );
        if(response?.length > 0){
            yield put (setBulkOrderManagedEquipmentDropDown({response,requestIndex: val?.requestIndex}))
        }
        yield put(globalLoaderText(""));

    } catch (error) {
        yield put(
            setBulkOrderManagedEquipmentDropDown({response: [],requestIndex: val?.requestIndex}))
        yield put(globalLoaderText(""));
    }
}

function* watchGetRequestType() {
    yield takeEvery(GET_VEHICLE_TYPE, getVehicleType)
    yield takeEvery(GET_MAKE_LIST, getMakeList)
    yield takeEvery(GET_VEHICLE_SPEC_LIST, getVehicleSpecList)
    yield takeEvery(GET_MANAGED_EQUIPEMENT_TYPES, getEquipmentDropdown)
    yield takeEvery(GET_CATALOG_ITEMS, getCatalogItem)
    yield takeEvery(UPLOAD_BULK_ORDER_ATTACHMENTS, uploadBulkOrderAttachments)
    yield takeEvery(GET_BULK_ORDER_MANAGED_EQUIPMENT_DROP_DOWN, getBulkOrderManagedEquipmentDropDown)
}

export default function* combinedSaga() {
    yield all([
        watchGetRequestType()
    ])
}